export const LEVEL_PROGRESS_GREY_COLOR = 'rgba(163, 163, 163, .5)';
export const LEVEL_PROGRESS_LIGHT_GREEN_COLOR = 'rgba(74, 222, 128, .5)';
export const LEVEL_PROGRESS_GREEN_COLOR = 'rgba(34, 197, 94, .55)';
export const LEVEL_PROGRESS_SPEED_PLAY_COMPLETE = '#6aeefc';
export const LEVEL_PROGRESS_OUTLINE = 'rgb(0,96,0)';
export const LEVEL_PROGRESS_BORDER_WIDTH = 1;
